"use strict";

function checkUrlParameters(array, attribute) {
  var parameterUrl = findGetParameter(attribute);

  if (parameterUrl != "") {
    var match = parameterUrl.split(',');

    for (var i in match) {
      var value = match[i];

      if (attribute == 'authors' && array == authorsArray) {
        initAuthors(parseInt(value));
      } else {
        $('[data-' + attribute + '="' + value + '"]').prop('checked', true);
      }

      addParametersToArray(array, value, attribute);
    }
  }
} // Panel Member Services


(function ($) {
  $.fn.panelCheckboxServices = function () {
    $(this).on('change', function () {
      if ($(this).hasClass('category') && $(this).prop('checked') == true) {
        addParametersToArray(categories, $(this).data('category'), 'category');
      } else if ($(this).hasClass('category') && $(this).prop('checked') == false) {
        removeParametersToArray(categories, $(this).data('category'), 'category');
      } else if ($(this).hasClass('provider') && $(this).prop('checked') == true) {
        addParametersToArray(providers, $(this).data('provider'), 'provider');
      } else if ($(this).hasClass('provider') && $(this).prop('checked') == false) {
        removeParametersToArray(providers, $(this).data('provider'), 'provider');
      } else if ($(this).hasClass('file') && $(this).prop('checked') == true) {
        addParametersToArray(files_services, $(this).val(), 'files');
      } else if ($(this).hasClass('file') && $(this).prop('checked') == false) {
        removeParametersToArray(files_services, $(this).val(), 'files');
      }

      vueServices.getMemberServices();
    });
  };
})(jQuery); // Panel Gesica Mag


(function ($) {
  $.fn.panelCheckboxArticles = function () {
    $(this).on('change', function () {
      if ($(this).hasClass('js-date') && $(this).prop('checked') == true) {
        addParametersToArray(dates_news, $(this).data('month'), 'month');
      } else if ($(this).hasClass('js-date') && $(this).prop('checked') == false) {
        removeParametersToArray(dates_news, $(this).data('month'), 'month');
      } else if ($(this).hasClass('js-date') && $(this).prop('checked') == true) {
        addParametersToArray(dates_news, $(this).data('month'), 'month');
      } else if ($(this).hasClass('js-date') && $(this).prop('checked') == false) {
        removeParametersToArray(dates_news, $(this).data('month'), 'month');
      } else if ($(this).hasClass('category') && $(this).prop('checked') == true) {
        addParametersToArray(categories_news, $(this).data('category'), 'category');
      } else if ($(this).hasClass('category') && $(this).prop('checked') == false) {
        removeParametersToArray(categories_news, $(this).data('category'), 'category');
      } else if ($(this).hasClass('js-file') && $(this).prop('checked') == true) {
        addParametersToArray(attachments_news, $(this).val(), 'attachments');
      } else if ($(this).hasClass('js-file') && $(this).prop('checked') == false) {
        removeParametersToArray(attachments_news, $(this).val(), 'attachments');
      }

      vueArticles.getArticles();
    });
  };
})(jQuery); // Panel Documents


(function ($) {
  $.fn.panelCheckboxDocuments = function () {
    $(this).on('change', function () {
      if ($(this).hasClass('js-date') && $(this).prop('checked') == true) {
        addParametersToArray(dates_docs, $(this).val(), 'year');
      } else if ($(this).hasClass('js-date') && $(this).prop('checked') == false) {
        removeParametersToArray(dates_docs, $(this).val(), 'year');
      } else if ($(this).hasClass('js-tag') && $(this).prop('checked') == false) {
        removeParametersToArray(tags_docs, $(this).val(), 'tags');
      } else if ($(this).hasClass('js-tag') && $(this).prop('checked') == true) {
        addParametersToArray(tags_docs, $(this).val(), 'tags');
      } else if ($(this).hasClass('js-author') && $(this).prop('checked') == false) {
        removeParametersToArray(authors_docs, $(this).val(), 'authors');
      } else if ($(this).hasClass('js-author') && $(this).prop('checked') == true) {
        addParametersToArray(authors_docs, $(this).val(), 'authors');
      } else if ($(this).hasClass('js-file') && $(this).prop('checked') == false) {
        removeParametersToArray(files_docs, $(this).val(), 'files');
      } else if ($(this).hasClass('js-file') && $(this).prop('checked') == true) {
        addParametersToArray(files_docs, $(this).val(), 'files');
      }

      vusDocs.getDocuments();
    });
  };
})(jQuery);

(function ($) {
  $.fn.panelCheckboxAttachments = function () {
    $(this).on('change', function () {
      if ($(this).hasClass('js-rubric') && $(this).prop('checked') == true) {
        addParametersToArray(rubrics_attachments, $(this).val(), 'rubrics');
      } else if ($(this).hasClass('js-rubric') && $(this).prop('checked') == false) {
        removeParametersToArray(rubrics_attachments, $(this).val(), 'rubrics');
      } else if ($(this).hasClass('js-file') && $(this).prop('checked') == true) {
        addParametersToArray(files_attachments, $(this).val(), 'files');
      } else if ($(this).hasClass('js-file') && $(this).prop('checked') == false) {
        removeParametersToArray(files_attachments, $(this).val(), 'files');
      }

      vueAttachments.getAttachments();
    });
  };
})(jQuery); // Panel Gesica Mag Events


(function ($) {
  $.fn.panelCheckboxEvent = function () {
    function eventByCheckbox() {
      if ($('.js-event-checkbox:checked').length == $('.js-event-checkbox').length) {
        setGetParameter('event', 'full');
      } else if ($('.js-event-checkbox:checked').length == 0) {
        setGetParameter('event', 'empty');
      } else if ($('.js-event-checkbox:checked').length == 1) {
        if ($('.js-event-checkbox:checked').data('event') == 'in_progress') {
          setGetParameter('event', 'in_progress');
        } else if ($('.js-event-checkbox:checked').data('event') == 'completed') {
          setGetParameter('event', 'completed');
        }
      }
    }

    eventByCheckbox();
    $(this).on('change', function () {
      eventByCheckbox();
      vueArticles.getArticles();
    });
    vueArticles.getArticles();
  };
})(jQuery);

$(function () {
  if ($('.js-event-checkbox').length) {
    $('.js-event-checkbox').panelCheckboxEvent();
  }
});